import React from "react";
import "../styling/HeavenlyVisionsArticle.css"; // We'll define the CSS below
import princeOfPeaceImage from "../images/jesusPhoto.png"; // Akiane's painting

function HeavenlyVisionsArticle() {
  return (
    <div className="hvFullPage">
      {/* Article Title */}
      <div className="hvImage">
          <img src={princeOfPeaceImage} alt="Prince of Peace Painting" id="princeOfPeaceImage" />
        </div>
      <h1 className="hvTitle">
        Akiane Kramarik’s Vision of Jesus and Colton Burpo’s Stunning Confirmation
      </h1>

      {/* Introduction */}
      <div className="hvSection">
        <h3 className="middle">Introduction</h3>
        <p>
          In the realm of divine visions and near-death experiences, few stories captivate believers and skeptics alike as much as those of Akiane Kramarik and Colton Burpo. Both claimed to have encountered Jesus Christ in remarkable ways—Akiane through a supernatural vision that led to her now-famous painting, <em>Prince of Peace</em>, and Colton through a near-death experience that confirmed her depiction of Christ. Their intertwined testimonies have intrigued many and bolstered faith in the reality of heaven.
        </p>
      </div>

      {/* Akiane Kramarik Section */}
      <div className="hvSection">
        <h3 className="middle">Akiane Kramarik: A Child Prodigy’s Vision of Christ</h3>

        <p>
          Akiane Kramarik was born in 1994 to a Lithuanian mother and an American father, neither of whom were religious at the time. Raised in an atheistic household, she had no prior exposure to Christianity. However, at the age of four, she began experiencing vivid visions of heaven and Jesus Christ. According to Akiane, these experiences were not mere dreams but profound encounters that left an indelible mark on her soul.
        </p>
        <p>
          By the age of eight, she felt compelled to capture the image of Jesus she had seen. With extraordinary artistic talent far beyond her years, she painted <em>Prince of Peace</em>, a strikingly lifelike portrait of Christ with piercing eyes, a strong yet compassionate expression, and a radiant presence. Akiane claimed that Jesus personally guided her hands as she painted, ensuring every detail was as she had seen in her vision.
        </p>
        <p>
          Her work quickly gained worldwide attention, especially among Christians who saw divine inspiration in her paintings. Many who had experienced near-death encounters or spiritual visions recognized her portrayal of Jesus as the same figure they had encountered.
        </p>
      </div>

      {/* Colton Burpo Section */}
      <div className="hvSection">
        <h3 className="middle">Colton Burpo’s Near-Death Experience and Astonishing Recognition</h3>

        <p>
          Colton Burpo’s story, widely known from the best-selling book <em>Heaven is for Real</em> (later adapted into a film), added another layer of credibility to Akiane’s depiction of Jesus.
        </p>
        <p>
          In 2003, at the age of four, Colton, the son of a small-town Nebraska pastor, suffered a life-threatening medical emergency when his appendix burst. While on the operating table, he experienced what he later described as a journey to heaven. When he recovered, he shocked his family by recounting vivid details about heaven, meeting long-deceased relatives he had never known, and most astonishingly, encountering Jesus Christ.
        </p>
        <p>
          Over the years, Colton’s father, Todd Burpo, showed him various artistic representations of Jesus, but Colton repeatedly dismissed them, saying none of them looked like the Jesus he had met in heaven. That changed when he was shown Akiane Kramarik’s <em>Prince of Peace</em>. Without hesitation, Colton pointed to the painting and confirmed, “That’s Him. That’s Jesus.”
        </p>
      </div>

      {/* Impact Section */}
      <div className="hvSection">
        <h3 className="middle">The Impact of Their Stories</h3>
        <p>
          The connection between Akiane and Colton’s experiences has had a profound impact on many people around the world. Their testimonies, though from two unrelated children with vastly different backgrounds, offer a compelling case for the reality of Jesus and heaven.
        </p>
        <p>
          Akiane went on to become one of the most recognized child prodigies in the world, using her art to share her divine experiences. Despite challenges—including her original <em>Prince of Peace</em> painting being stolen for over 16 years—her faith and dedication remained steadfast.
        </p>
        <p>
          Colton Burpo’s story continues to inspire millions, as his firsthand account of heaven resonates deeply with those seeking assurance of life after death.
        </p>
      </div>

      {/* Skepticism and Faith Section */}
      <div className="hvSection">
        <h3 className="middle">Skepticism and Faith</h3>
        <p>
          While many believers see Akiane and Colton’s stories as divine affirmations, skeptics argue that near-death experiences can be explained by neurological activity or subconscious influences. Some critics also question the legitimacy of Akiane’s visions, attributing her artistic skills to natural talent rather than divine intervention.
        </p>
        <p>
          However, neither Akiane nor Colton have wavered in their testimonies. Their stories remain among the most intriguing modern accounts of heaven and Jesus Christ, reinforcing faith for countless individuals worldwide.
        </p>
      </div>

      {/* Conclusion */}
      <div className="hvSection">
        <h3 className="middle">Conclusion</h3>
        <p>
          The convergence of Akiane Kramarik’s vision-driven artwork and Colton Burpo’s near-death experience presents an extraordinary and faith-affirming narrative. While skeptics continue to debate the supernatural elements, their accounts undeniably inspire believers and invite deeper contemplation about the nature of heaven, Jesus, and the mysteries of the divine. Whether one views their experiences as miraculous or coincidental, their stories have left an undeniable imprint on the conversation about faith and the afterlife.
        </p>
      </div>
    </div>
  );
}

export default HeavenlyVisionsArticle;

